import StatusHandler from 'app/shared-components/StatusHandler'
import {
    WithId,
} from 'app/types/common.types'

import useGetServiceCenterById from '../hooks/useGetServiceCenterById'
import ServiceCenterForm from '../ServiceCenterForm'
import useGetProductMetrics from '../hooks/useGetProductMetrics'

const ServiceCenterOverview = ({
    id,
}: Readonly<WithId<number>>) => {
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
    } = useGetServiceCenterById(id)

    // get productMetrics data for overview tab with the separate request
    // to have property usableContainersAmount

    const {
        data: productMetricsData,
        isDataReady: isDataReadyProductMetrics,
    } = useGetProductMetrics(id)

    return (
        <StatusHandler
            isSuccess={
                isDataReady && isDataReadyProductMetrics
                && Boolean(data) && Boolean(productMetricsData)
            }
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <ServiceCenterForm
                data={{
                    ...data,
                    ...productMetricsData,
                }}
                exists
                disabled
            />
        </StatusHandler>
    )
}

export default ServiceCenterOverview
